import { RequestBase, RequestBaseIds, RequestBasePageIds, RequestBaseSet, RequestDelete, RequestDeleteIds, ResponseBase, ResponseBasePage, ResponseBaseSet } from "src/app/modules/fwcore/models";
import { Deal } from "src/app/features/prob/models";



export class RequestDeal extends RequestBasePageIds {

  /**
 * The identifier of the company associated with the deal.
 */
  companyId?: string | null;

  /**
   * The identifier of the deal group to filter deals by.
   */
  dealGroupId?: string | null;

  /**
   * The identifier of the deal folder to filter deals by.
   */
  dealFolderId?: string | null;

  /**
   * The status code for the deals we wish to match.
   */
  dealStatusCode?: string | null;

  /**
   * Indicates whether to include all deals associated with the user's company.
   */
  viewCompanyDeals?: boolean | null;

  /**
   * Indicates whether only active deals should be included.
   */
  isActive?: boolean | null;

  /**
   * Indicates whether to include only deals that have been received.
   */
  onlyReceived?: boolean | null;

  /**
   * Indicates whether to include only deals shared with the current user.
   */
  sharedWith?: boolean | null;

  /**
   * The company identifier for whom we wish to filter deals created for
   */
  userCompanyId?: string | null;

  /**
  * The user group code to validate permissions against.
  */
  userGroupCode?: string | null;
  /**
* The task Id to get imported scenario.
*/
  taskId?: string | null;

  /**
  * The importStatus to get imported scenario.
  */
  importStatus?: string | null;

  /**
  * Indicates whether to include only deals that are Unopened.
  */
  Unopened?: boolean | null;

  /**
  * Indicates whether to include only deals that have been updated.
  */
  Updated?: boolean | null;

}

export class ResponseDeal extends ResponseBasePage<Deal> {

}

export class RequestDealSet extends RequestBaseSet<Deal>
{
  /**
   * The company identifier for whom we wish to create deals for
   */
  userCompanyId?: string | null;

  /**
  * The user group code to validate permissions against.
  */
  userGroupCode?: string | null;
}

export class ResponseDealSet extends ResponseBaseSet<Deal>{
}

export class RequestDealStateSet extends RequestBaseIds<string> {

  /**
   * Remove any user draft changes
   */
  removeUserChanges?: boolean | null;
}

export class ResponseDealStateSet extends ResponseBase {

}

export class RequestDealDelete extends RequestDeleteIds {

  /**
   * If true, the deal will be marked for deletion. Otherwise, it will be soft deleted isactive set to false.
   */
  hardDelete?: boolean | null;

  /** Permanently delete */
  permDelete?: boolean | null;
}

export class RequestDealRestore extends RequestDeleteIds {


}

export class RequestDealLocking extends RequestBase {

  dealId?: string | null;
  lock?: boolean | null;
}

export class ResponseDealLocking extends ResponseBase {

}

